//@flow
import React from 'react'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import './styles.scss'

const isMobile = browserCheck.isMobile

const Arrow = ({ fill }) => (
  <svg id="Layer_1" width="38.5" height="24" x="0" y="0">
    <polygon class="st0" points="27.2971096,13.8469629 27.2546997,9.9458313 3.5,10.1407633 3.4404831,4.6658707 27.1951828,4.4709387 
	27.1517773,0.4781012 35.6805229,7.085927 "/>
  </svg>
);

export class Explainer extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
  }

  render() {
    return <div className='explainer'>
      <h3>In mehreren Schritten zum besten Ergebnis</h3>
      <div className="columns">

        <div className="row">
          <div className="column">
            <img src={require('./0.jpg')} alt="step" />
          </div>
          <div className="spacer">
            <div className="label">Anweisung</div>
            <Arrow />
          </div>
          <div className="column">
            <img src={require('./1.jpg')} alt="step" />
          </div>
        </div>

        <div className="row">
          <div className="column">
            <img src={require('./2.jpg')} alt="step" />
          </div>
          <div className="spacer">
            <div className="label">Outpainting</div>
            <Arrow />
          </div>
          <div className="column">
            <img src={require('./3.jpg')} alt="step" />
          </div>
        </div>

        <div className="row">
          <div className="column">
            <img src={require('./4.jpg')} alt="step" />
          </div>
          <div className="spacer">
            <div className="label">Inpainting</div>
            <Arrow />
          </div>
          <div className="column">
            <img src={require('./5.jpg')} alt="step" />
          </div>
        </div>


      </div>
    </div>
  }
}
